module.exports = __webpack_public_path__ + "static/mock_1-6d8ea7df38a7403cb5c616118e31e7fb.png";